var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRotateCcw = function SvgRotateCcw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.903 1.953a9.952 9.952 0 1 1-9.95 9.95.6.6 0 1 1 1.199 0 8.752 8.752 0 0 0 17.334 1.707 8.754 8.754 0 0 0-8.582-10.458 9.53 9.53 0 0 0-6.58 2.671L4 7.147h3.747a.6.6 0 0 1 0 1.2H2.552a.6.6 0 0 1-.117-.012q-.035-.009-.07-.02L2.325 8.3a.6.6 0 0 1-.27-.222l-.018-.03a.6.6 0 0 1-.083-.301V2.552a.6.6 0 1 1 1.199 0V6.3l1.324-1.325.007-.007a10.73 10.73 0 0 1 7.418-3.015z"
  })));
};
export default SvgRotateCcw;